import { Cancel, DeleteOutline, Edit, Visibility } from "@mui/icons-material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import AddPhoto from "../../assets/svg/AddPhoto.svg";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { TextField } from "@mui/material";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";

export default function TemplateProfile() {
  const { id } = useParams();

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  // preview functions

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  // delete functions

  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = () => {
    setShowDelete(true);
  };

  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const deleteTemplate = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/notification-templates/${id}`,
        {
          headers,
        }
      );
      toast.warning("Template Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      navigate("/Templates");
    } catch (error) {
      toast.error("Failed To Delete This Template.");
      console.log(error.message);
    }
  };

  // template data functions

  const [templateData, setTemplateData] = useState(null);

  const [version, setVersion] = useState(false);

  const getTemplateInfo = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/notification-templates/${id}`,
        { headers }
      );
      console.log(response.data.data.template);
      setTemplateData(response.data.data.template);
      //   setProductData(response.data.data.variation);
      //   setCategoryId(response.data.data.variation?.product?.category?.id);
      //   setProductBrandId(response.data.data.variation?.product?.brand?.id);
    } catch (error) {
      console.log(error);
    }
  };

  //  effects

  useEffect(() => {
    getTemplateInfo();
  }, []);

  return (
    <>
      {/* preview template */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            <p className=" my-0 small">Template Preview</p>
            <div className=" cursor" onClick={handleClose}>
              <Cancel />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className=" border border-1 rounded-3 p-3">
            <p className=" fw-semibold mb-2">Welcome Email</p>
            <p className=" text-muted small my-2">Hello {"user_name"}</p>
            <p className=" text-muted small my-2">
              Welcome to our platform! We're excited to have you on board.
            </p>
            <p className=" text-muted mb-0 small">Best regards,</p>
            <p className=" text-muted my-0 small">The Team</p>
            <hr />
            <p className=" fw-semibold mb-2">Variables used</p>
            <p className=" text-muted small my-2">User_name</p>
            <p className=" text-muted small my-1">Omar Ali</p>
          </div>
        </Modal.Body>
      </Modal>
      {/* delete template */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this template?"}
        deleteFunction={deleteTemplate}
      />
      {/* template profile */}
      <div className="m-4">
        {/* Header */}
        <div className="row">
          <div className="col-12 text-center col-xl-3 text-xl-start">
            <h3 className="mb-0">Template Profile</h3>
          </div>
          <div className="col-12 col-sm-6 col-md-4 text-center col-xl-2 text-xl-end">
            <button
              onClick={() => setVersion(false)}
              className={`btn ${
                version ? "btn-light border" : "btn-dark"
              }  stock-button`}
            >
              Template Info
            </button>
          </div>
          <div className="col-12 col-sm-6 col-md-4 text-center col-xl-1">
            <button
              onClick={() => setVersion(true)}
              className={`btn ${
                version ? "btn-dark" : "btn-light border"
              } px-3 stock-button`}
            >
              Versions
            </button>
          </div>
          <div className="col-12 col-sm-8 col-md-4 mx-sm-auto text-center col-xl-6 text-xl-end">
            <button onClick={handleShow} className="btn btn-light stock-button">
              <Visibility className="me-2 text-muted" />
              Preview
            </button>
            <button
              //   onClick={handleDeleteProduct}
              className="btn btn-light stock-button mx-2"
            >
              <Edit className="text-muted" />
            </button>
            <button
              onClick={() => confirmDelete()}
              className="btn btn-light stock-button"
            >
              <DeleteOutline className="text-danger" />
            </button>
          </div>
        </div>
        {/* template data */}
        {version ? (
          <div className="border border-2 rounded-3 my-4 p-3 p-md-4">
            <div className=" border-bottom pb-3 ">
              <p className="fs-5 fw-semibold mb-0">Versions History</p>
            </div>
          </div>
        ) : (
          <div className="border border-2 rounded-3 my-4 p-3 p-md-4">
            <div className=" border-bottom pb-3 ">
              <p className="fs-5 fw-semibold mb-0">Template Info</p>
            </div>
            {/* basic info */}
            <div className="py-3">
              <p className="fs-5 fw-semibold mb-3">1. Basic Info:</p>
              <div className="row gy-3">
                <div className="col-sm-6 ">
                  <div className="fw-semibold d-flex align-items-center gap-2">
                    <span className="text-muted">Template Name :</span>
                    {templateData?.name}
                  </div>
                </div>
                <div className="col-sm-6 ">
                  <span className="text-muted fw-semibold">Category :</span>{" "}
                  {templateData?.category?.name}
                </div>
                <div className="col-sm-6 ">
                  <span className="text-muted fw-semibold">
                    Template Code :{" "}
                  </span>{" "}
                  {templateData?.code || "undefined"}
                </div>
                <div className="col-sm-6 ">
                  <span className="text-muted fw-semibold">Status :</span>{" "}
                  {templateData?.status}
                </div>
              </div>
            </div>
            {/* content */}
            <div className="pt-3">
              <p className="fs-5 fw-semibold mb-2">2. Content:</p>
              <div className="row g-3">
                {/* image */}
                <div className="col-2">
                  <p className="mb-2">Template Image</p>
                  <div
                    className="border border-1 d-flex justify-content-center align-items-center rounded p-2"
                    style={{ height: "175px" }}
                  >
                    <img
                      src={
                        templateData?.image_url
                          ? `https://estbn.com/EstbnNew/public${templateData?.image_url}`
                          : AddPhoto
                      }
                      style={{
                        //    width: "50%",
                        height: "160px",
                        objectFit: "cover",
                      }}
                      alt="Profile"
                      className="rounded"
                    />
                  </div>
                </div>
                {/* body */}
                <div className="col-12">
                  <p className="mb-2">Body Content *</p>
                  <div
                    className="border border-1 rounded p-2"
                    style={{
                      height: "175px",
                      overflow: "scroll",
                    }}
                  >
                    {templateData?.body}
                  </div>
                </div>
                <div className="row my-4">
                  <label className="my-1" htmlFor="">
                    Variables
                  </label>
                  <div className="col-md-6">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      value={"Variable Name"}
                    />
                  </div>
                  <div className="col-md-6">
                    <TextField
                      className="w-100"
                      size="small"
                      type="text"
                      value={"Variable Name"}
                    />
                  </div>
                </div>
                {/* <p className="mb-2">Variables</p> */}
                {/* {templateData?.variables?.map((vari)=>
                <div className="col-6">
                <TextField
                id=""
                label=""
                value={vari?.firstname}
                //   onChange={}                         
                />
                </div>
               )} */}
              </div>
              <p className="fs-5 fw-semibold mb-2">3. Advanced Settings:</p>
              <div className="my-2 ">
                <p className="main-text-color">Translations</p>
                <div className=" border rounded-2 p-3">
                  <div className="row">
                    <label className="my-1" htmlFor="">
                      Language Code
                    </label>
                    <div className="col-md-6">
                      <TextField
                        className="w-100"
                        size="small"
                        type="text"
                        value={"Variable Name"}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <label className="my-1" htmlFor="">
                      Translated Title
                    </label>
                    <div className="col-md-6">
                      <TextField
                        className="w-100"
                        size="small"
                        type="text"
                        value={"Translated Title"}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <label className="my-1" htmlFor="">
                      Translated Body
                    </label>
                    <div className="col-md-6">
                      <TextField
                        className="w-100"
                        size="small"
                        type="text"
                        value={"Translated Body"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
